import {Additive, Additives} from "./additives";
export class Ingredient {
  public id : string;
  public title : string;
  public name : string;
  public included : boolean;
  public prices : Object;
  public price;
  public additives : Additive[] = [];
  public deduct_on_removal = false;
  constructor(payload){
    this.id = payload.id;
    this.title = payload.title;
    this.name = payload.name;
    this.included = payload.included;
    this.prices = payload.overrides.prices || payload.prices || payload.parentPrices;
    this.price = payload.price;
    this.deduct_on_removal = payload.deduct_on_removal;
    if (payload.additives) {
      this.additives = payload.additives.map(add => {
        return Additives.nameByNumber(add.number);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/ingredient.ts